import React, { useEffect } from 'react'
import useStore from '@/store'
import classNames from 'classnames'
import type { Props } from './types'
import Locations from '@/components/locations'
import styles from './style.module.scss'
import useMeasure from '@/hooks/use-measure'

const Switzerland: React.FC<Props> = ({ customRef }) => {
  const onPointerMove = useMeasure('switzerland', false, customRef)
  const locationsData = useStore((state) => state.locationsData)
  const setModal = useStore((state) => state.setModal)
  const setAvailableCategories = useStore(
    (state) => state.setAvailableCategories
  )
  const setActiveCategoryFilter = useStore(
    (state) => state.setActiveCategoryFilter
  )
  const classes = classNames(styles['switzerland-view'])

  const switzerlandLocationsData = locationsData?.filter(
    (l) => l.attributes.Position.Map === 'Switzerland'
  )

  useEffect(() => {
    setModal({ content: undefined }, 'top')
    setModal({ content: undefined }, 'bottom')
    setActiveCategoryFilter('', 'top')
    setActiveCategoryFilter('', 'bottom')
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (locationsData)
      setAvailableCategories([
        ...new Set(
          switzerlandLocationsData?.map(
            (l) => l.attributes.Category.data.attributes.Slug
          )
        ),
      ])
    // eslint-disable-next-line
  }, [locationsData])

  return (
    <div ref={customRef} className={classes} onPointerMove={onPointerMove}>
      <figure
        className={styles['bg-map']}
        style={{
          backgroundImage: `url(${require('@/assets/images/bg-switzerland_1200.png')})`,
        }}
      />
      <Locations locations={switzerlandLocationsData} />
    </div>
  )
}

export default React.memo(Switzerland)
